var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ClientLayout',[(_vm.exists)?_c(("page-" + _vm.section + "-" + _vm.page),{tag:"component"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }